import useUrl from './helpers/useUrl'

export default (client) => {
  const root = useUrl('wof')

  return {
    /**
     * @returns {Promise<Response<GetListAllWOFResponse>>}
     * */
    getListAll() {
      const url = root('list-all')
      return client.get(url)
    },
    /**
     * @returns {Promise<Response<GetListUserWOFResponse>>}
     *
     * */
    getListUser() {
      const url = root('list-user')
      return client.get(url)
    },
    /**
     * @returns {Promise<Response<GetAccountWOFResponse>>}
     * */
    account() {
      const url = root('account')
      return client.get(url)
    },
    /**
     * @param {object} SpinWOFDTO
     * @param {string} SpinWOFDTO.uuid
     *
     * @returns {Promise<Response<GetListUserWOFResponse>>}
     * */
    spin({ uuid }) {
      const url = root('spin')
      return client.post(url, { uuid })
    },
  }
}

/** @typedef {object} GetListAllWOFResponse
 * @property {boolean} status
 * @property {object[]} result
 * @property {string} result.uuid
 * @property {string} result.name
 * @property {string} result.description
 * @property {number} result.ttl
 * @property {null} result.iconUrl
 * @property {object[]} result.wofGifts
 * @property {string} result.wofGifts.uuid
 * @property {string} result.wofGifts.name
 * @property {string} result.wofGifts.description
 * @property {number} result.wofGifts.referenceId
 * @property {string} result.wofGifts.serviceName
 * @property {number} result.wofGifts.serviceReferenceId
 * @property {string} result.wofGifts.iconUrl
 */

/** Empty According to http://10.1.0.2:3918/api/doc/wof#/Public%20wof/WofPublicController_getUserWofs
 * @typedef {object} GetListUserWOFResponse
 * @property {boolean} status
 * @property {object[]} result
 * @property {object[]} result.gifts
 * @property {object[]} result.wofGifts
 */

/** @typedef {object} GetAccountWOFResponse
 * @property {boolean} status
 * @property {object} result
 * @property {number} result.userId
 * @property {number} result.balance
 * @property {number} result.goal
 * @property {number} result.progress
 */
